(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["styles"],{

/***/ "./node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/lib/loader.js?!./src/styles.scss":
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!./node_modules/postcss-loader/src??embedded!./node_modules/sass-loader/lib/loader.js??ref--15-3!./src/styles.scss ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = [[module.i, "body {\n  font-family: \"Merriweather\", serif;\n}\n\nh1 {\n  margin: 1rem 0.5rem;\n  text-align: center;\n}\n\n.toolbar {\n  background: #DDD;\n  border-radius: 0.5rem;\n}\n\n.card {\n  width: 2.5in;\n  max-width: 2.5in;\n  min-width: 2.5in;\n  height: 3.5in;\n  max-height: 3.5in;\n  min-height: 3.5in;\n  border: 1px solid gray;\n  border-radius: 0.1in;\n}\n\n.card .card-img-overlay {\n  padding: 0.25rem;\n}\n\n.card .card-image-area {\n  width: 100%;\n  height: 2in;\n  max-height: 2in;\n  min-height: 2in;\n}\n\n.card .card-img {\n  width: 2.5in;\n  height: 3.5in;\n  -o-object-fit: cover;\n     object-fit: cover;\n  max-width: 2.5in;\n  max-height: 3.5in;\n  opacity: 0.6;\n  -webkit-filter: saturate(40%);\n          filter: saturate(40%);\n  border-radius: 0.1in;\n}\n\n.card .card-title {\n  overflow: hidden;\n  margin: 0;\n  font-size: 0.15in;\n  font-weight: 800;\n  text-align: center;\n}\n\n.card .card-title .card-character-name {\n  vertical-align: middle;\n  margin: auto auto;\n}\n\n.card .card-title .card-title-inner {\n  margin: 0.05in 0.05in;\n  border: 3px solid #444;\n  border-radius: 0.05in;\n  background: #ccc;\n  color: #FFF;\n  height: 0.5in;\n}\n\n.card .card-numbers {\n  background: transparent;\n}\n\n.card .card-ability {\n  background: #FFF;\n  border-radius: 0.15in;\n  border: 3px solid #444;\n  font-size: 0.125in;\n  line-height: 0.125in;\n  height: 0.7in;\n  margin-top: -0.05in !important;\n  overflow: hidden;\n}\n\n.card .card-ability .card-ability-inner {\n  max-height: 0.45in;\n  margin: -0.025in 0.05in 0 0.05in !important;\n}\n\n.card .card-ability .card-ability-inner span {\n  display: inline-block;\n  text-align: left;\n}\n\n.card .card-ability .card-ability-header {\n  background: #ccc;\n  color: #FFF;\n  padding: 0.05in 0;\n}\n\n.card img.character {\n  max-width: 2in;\n  max-height: 1.95in;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.card .brawl, .card .priority {\n  font-size: 0.2in;\n}\n\n.card .brawl {\n  margin-left: -0.03in;\n}\n\n.card .brawl img {\n  margin-top: -0.4in;\n  width: 0.75in;\n  height: auto;\n}\n\n.card .brawl .brawl-text {\n  color: #FFF;\n  margin-top: -0.45in;\n  margin-left: -0.075in;\n  font-weight: 700;\n}\n\n.card .priority {\n  margin-left: 0.08in;\n}\n\n.card .priority img {\n  margin-top: -0.3in;\n  width: 0.5in;\n  height: auto;\n}\n\n.card .priority .priority-text {\n  color: #FFF;\n  margin-top: -0.46in;\n  margin-left: -0.03in;\n  font-weight: 700;\n}\n\n.card.nova .card-body {\n  background: url(/assets/images/backgrounds/nova.jpg);\n}\n\n.card.nova .card-ability-header, .card.nova .card-title-inner {\n  background: #272051;\n}\n\n.card.fiendheim .card-body {\n  background: url(/assets/images/backgrounds/fiendheim.jpg);\n}\n\n.card.fiendheim .card-ability-header, .card.fiendheim .card-title-inner {\n  background: #591615;\n}\n\n.card.arth .card-body {\n  background: url(/assets/images/backgrounds/arth.jpg);\n}\n\n.card.arth .card-ability-header, .card.arth .card-title-inner {\n  background: #4D4B48;\n}\n\n/** Dragula tweaks **/\n\n/* in-flight clone */\n\n.gu-mirror {\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n  filter: alpha(opacity=80);\n  pointer-events: none;\n}\n\n/* high-performance display:none; helper */\n\n.gu-hide {\n  left: -9999px !important;\n}\n\n/* added to mirrorContainer (default = body) while dragging */\n\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n/* added to the source element while its mirror is dragged */\n\n.gu-transit {\n  opacity: 0.2;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n  filter: alpha(opacity=20);\n}\n/*# sourceMappingURL=data:application/json;base64,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 */", '', '']]

/***/ }),

/***/ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/*!****************************************************************************!*\
  !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stylesInDom = {};

var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

function listToStyles(list, options) {
  var styles = [];
  var newStyles = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      css: css,
      media: media,
      sourceMap: sourceMap
    };

    if (!newStyles[id]) {
      styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });
    } else {
      newStyles[id].parts.push(part);
    }
  }

  return styles;
}

function addStylesToDom(styles, options) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i];
    var domStyle = stylesInDom[item.id];
    var j = 0;

    if (domStyle) {
      domStyle.refs++;

      for (; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j]);
      }

      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j], options));
      }
    } else {
      var parts = [];

      for (; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j], options));
      }

      stylesInDom[item.id] = {
        id: item.id,
        refs: 1,
        parts: parts
      };
    }
  }
}

function insertStyleElement(options) {
  var style = document.createElement('style');

  if (typeof options.attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      options.attributes.nonce = nonce;
    }
  }

  Object.keys(options.attributes).forEach(function (key) {
    style.setAttribute(key, options.attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  }

  if (sourceMap && btoa) {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {};
  options.attributes = typeof options.attributes === 'object' ? options.attributes : {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  var styles = listToStyles(list, options);
  addStylesToDom(styles, options);
  return function update(newList) {
    var mayRemove = [];

    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];

      if (domStyle) {
        domStyle.refs--;
        mayRemove.push(domStyle);
      }
    }

    if (newList) {
      var newStyles = listToStyles(newList, options);
      addStylesToDom(newStyles, options);
    }

    for (var _i = 0; _i < mayRemove.length; _i++) {
      var _domStyle = mayRemove[_i];

      if (_domStyle.refs === 0) {
        for (var j = 0; j < _domStyle.parts.length; j++) {
          _domStyle.parts[j]();
        }

        delete stylesInDom[_domStyle.id];
      }
    }
  };
};

/***/ }),

/***/ "./src/styles.scss":
/*!*************************!*\
  !*** ./src/styles.scss ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(/*! !../node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../node_modules/postcss-loader/src??embedded!../node_modules/sass-loader/lib/loader.js??ref--15-3!./styles.scss */ "./node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/lib/loader.js?!./src/styles.scss");

if (typeof content === 'string') {
  content = [[module.i, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = __webpack_require__(/*! ../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}


/***/ }),

/***/ 6:
/*!*******************************!*\
  !*** multi ./src/styles.scss ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/dqj/dev/personal/xalliances/src/styles.scss */"./src/styles.scss");


/***/ })

},[[6,"runtime"]]]);
//# sourceMappingURL=styles-es2015.js.map